// TES-1034 (Emelie's point 8) — how a handoff names its sender.
//
// The coach receiving a doctor's handoff must see who sent it and when. The
// DTO carried the sender's id, role and time all along; nothing rendered
// them. (The priority's Swedish label is `levelLabel` in state-labels.)
//
// Pure on purpose (no React, only type imports) so `node --test` can run it.
import type { HandoffDto } from "@care-by-ella/contracts";

const ROLE_LABELS: Record<string, string> = {
  coach: "coach",
  doctor: "läkare",
  // TES-1110 — staff escalating from the Support inbox.
  admin: "Ella Support",
  system: "system",
};

/**
 * "Från: Dr. Kirill (läkare) · 2026-09-30 14:05" in Swedish time. A system
 * producer has no person, and an unknown sender reads as the role alone.
 */
export function handoffSenderLine(
  h: Pick<HandoffDto, "fromRole" | "createdAt" | "createdByDisplayName">,
): string {
  const role = ROLE_LABELS[h.fromRole] ?? h.fromRole;
  const who = h.createdByDisplayName
    ? `${h.createdByDisplayName} (${role})`
    : role.charAt(0).toUpperCase() + role.slice(1);
  const when = new Date(h.createdAt).toLocaleString("sv-SE", {
    timeZone: "Europe/Stockholm",
    dateStyle: "short",
    timeStyle: "short",
  });
  return `Från: ${who} · ${when}`;
}
